import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "./auth";
import Loading from "../../components/loading/Loading";

const ProtectedRoute = () => {

    const { user, loading } = useAuth();

    if (loading) {
        return (
            <div style={{
                height: "100dvh", width: "100dvw", display: "grid", placeItems: "center"
            }}>
                <Loading />
            </div>
        );
    }

    if (!user) {
        localStorage.clear();
        return <Navigate to="/login" replace />;
    }

    return <Outlet />;
};

export default ProtectedRoute;
